import FlagIcon from '@mui/icons-material/Flag';
import { Tooltip } from '@mui/material';
import React from 'react';

const PriorityFlag = (props) => {
  const { priority } = props;
  const definePriorityColor = () => {
    if (priority === 'Critique') {
      return 'firebrick';
    } else if (priority === 'Haute') {
      return 'orange';
    }
    return 'lightgrey';
  };

  return (
    <>
      <Tooltip title={priority} placement="top">
        <FlagIcon style={{ color: definePriorityColor() }} />
      </Tooltip>
    </>
  );
};

export default PriorityFlag;
